export default __webpack_public_path__ + "static/media/raise.2eb80cee.png";